<template>
  <div class="phone-input" :class="{ invalid: !valid }">
    <label :for="config.key">
      {{ config.label }}
      <sup v-if="config.required">*</sup>
    </label>
    <input
      :id="config.key"
      :required="config.required"
      type="text"
      v-model="model"
      ref="phone">
      <span class="error--text" v-if="!valid">{{ $t('inputs.phone.error') }}</span>
  </div>
</template>

<script>
  /* global IntlTelInput */
  import '@/../static/vendor/intl-tel-input/intlTelInput.js'
  import { mapGetters } from 'vuex'
  import input from '@/mixins/input'
  export default {
    props: {
      checkInterval: {
        type: Number,
        default: 500
      }
    },
    mixins: [input],
    data () {
      return {
        intlTelInput: null,
        model: this.value,
        utilLibLoaded: false
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform'
      }),
      number () {
        return this.model && this.intlTelInput && this.intlTelInput.getNumber()
      },
      valid () {
        if (!this.model) { return true }
        if (!this.intlTelInput) { return true }
        if (!this.utilLibLoaded) { return true }
        if (this.platform.settings.allowedCountries.length > 0 && this.platform.settings.allowedCountries.indexOf(this.intlTelInput.getSelectedCountryData().iso2) < 0) { return false }
        return this.intlTelInput.isValidNumber()
      }
    },
    watch: {
      model () {
        if (!this.valid) { return }
        this.emit(this.number)
      }
    },
    methods: {
      checkForUtilLib () {
        if (window.intlTelInputUtils) {
          this.utilLibLoaded = true
        } else {
          setTimeout(() => this.checkForUtilLib(), this.checkInterval)
        }
      }
    },
    mounted () {
      this.intlTelInput = new IntlTelInput(this.$refs.phone, {
        utilsScript: `/static/vendor/intl-tel-input/utils.js`,
        defaultCountry: 'fr',
        onlyCountries: this.platform.settings.allowedCountries || []
      })
      this.checkForUtilLib()
    }
  }
</script>

<style lang="stylus">
  @import "../../variables"
  @import "../../../static/vendor/intl-tel-input/intlTelInput.css"

  .phone-input {
    width: 100%;
    margin-bottom: 2em;

    label {
      font-size: $label-font-size;
      display: block;
      color: rgba(0,0,0,0.38);
    }

    .intl-tel-input {
      width: 100%;
    }

    input {
      width: 100%;
      outline: none;
      height: $input-height;
      font-size: $input-font-size;
      color: #000;
      border-bottom: solid 1px rgba(0,0,0,0.12);

      &:focus {
        border-bottom: solid 2px $theme.primary;
      }
    }

    &.invalid input:focus {
      border-bottom-color: $theme.error;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/Phone.vue